// import React from 'react';
// import logo from './logo.svg';
import './App.css';
import ColorGuesser from './ColorGuesser';

function App() {
  return (
    <div className="App">
      <ColorGuesser />
    </div>
  );
}

export default App;
